export const BRAND = {
  name: "DietDotIn",
  tagline: "Consistency Rewires You",
  whatsapp: "917259317088",
  whatsappDisplay: "+91 72593 17088",
  email: "pooja@dietdotin.com",
  city: "Bangalore, India",
  // Direct slot-booking — set this to your real Calendly URL once your event
  // is published, e.g. "https://calendly.com/pooja-dietdotin/consultation-30min".
  // Leave as null (or the placeholder below) to gracefully fall back to the
  // in-page consultation form + WhatsApp.
  calendlyUrl: "https://calendly.com/pooja-dietdotin/30min",
};

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Philosophy", href: "#philosophy" },
  { label: "Services", href: "#services" },
  { label: "Habit Plan", href: "#habit-plan" },
  { label: "Founder", href: "#founder" },
  { label: "Process", href: "#process" },
  { label: "Stories", href: "#testimonials" },
  { label: "FAQ", href: "#faq" },
];

export const PHILOSOPHY = [
  {
    key: "lotus",
    title: "Lotus",
    sub: "Mental Wellness",
    desc: "Calm clarity, inner balance, and the emotional groundwork that makes lasting change possible.",
    img: "/generated/lotus.png",
  },
  {
    key: "weights",
    title: "Weights",
    sub: "Physical Strength",
    desc: "Strong body, strong systems. Build metabolic resilience with smart, sustainable movement.",
    img: "/generated/weights.png",
  },
  {
    key: "spoon",
    title: "Spoon",
    sub: "Healthy Eating",
    desc: "Nourishing, culturally rooted nutrition — never bland, never restrictive, always evidence-led.",
    img: "/generated/spoon.png",
  },
  {
    key: "water",
    title: "Water",
    sub: "Hydration & Discipline",
    desc: "The quiet daily rituals — hydration, sleep, consistency — that compound into transformation.",
    img: "/generated/water.png",
  },
];

export const SERVICES = [
  {
    title: "Fat Loss",
    desc: "Sustainable, science-backed fat loss without crash diets. Tailored macros, lifestyle coaching, and real food you'll actually enjoy.",
    benefits: [
      "Personalised calorie & macro plan",
      "Weekly progress reviews",
      "Behavioural & habit coaching",
      "No deprivation, no detox myths",
    ],
    icon: "flame",
  },
  {
    title: "Therapeutic Diets",
    desc: "Clinical nutrition for PCOS, thyroid, diabetes, gut health and lifestyle disorders — built around your bloodwork.",
    benefits: [
      "PCOS, Thyroid & Diabetes protocols",
      "Gut healing & anti-inflammatory plans",
      "Doctor-aligned, evidence-led",
      "Symptom tracking & adjustments",
    ],
    icon: "stethoscope",
  },
  {
    title: "Mental Health Wellness",
    desc: "Mindful eating, stress & emotional eating support — because nutrition without the mind never lasts.",
    benefits: [
      "Mindful eating frameworks",
      "Stress & emotional eating tools",
      "Sleep & circadian coaching",
      "Habit identity rewiring",
    ],
    icon: "brain",
  },
];

export const CONDITIONS = [
  "Obesity",
  "PCOS / PCOD",
  "Thyroid",
  "Diabetes",
  "Insulin Resistance",
  "Emotional Eating",
  "Stress Eating",
  "Gut & Digestive Issues",
  "High Cholesterol",
  "Hypertension",
  "Lifestyle Disorders",
  "Post-Pregnancy Recovery",
];

export const PROCESS_STEPS = [
  {
    n: "01",
    title: "Consultation",
    desc: "Begin with a deep-dive consultation to understand your goals, history and lifestyle.",
  },
  {
    n: "02",
    title: "Health Assessment",
    desc: "Bloodwork review, body composition, sleep, stress and current eating patterns.",
  },
  {
    n: "03",
    title: "Personalised Diet Plan",
    desc: "A plan built for your culture, schedule, taste and clinical needs — not a template.",
  },
  {
    n: "04",
    title: "Lifestyle Coaching",
    desc: "Mindset, movement, sleep and behaviour coaching woven into every week.",
  },
  {
    n: "05",
    title: "Progress Tracking",
    desc: "Weekly check-ins, data-led adjustments, and accountability that keeps you on track.",
  },
];

export const TESTIMONIALS = [
  {
    initials: "AR",
    name: "Aanya R.",
    role: "Software Engineer, Bangalore",
    text:
      "Within 3 months I noticed sustainable changes in both my energy levels and eating habits. The guidance was practical, supportive, and easy to follow.",
  },
  {
    initials: "SM",
    name: "Sahana M.",
    role: "PCOS Recovery",
    text:
      "My PCOS markers improved and my cycles regularised. What I loved most — no fad diets, no shaming, just a clear plan I could actually live with.",
  },
  {
    initials: "VK",
    name: "Vikas K.",
    role: "Fat Loss Client",
    text:
      "Lost 14 kg over 7 months without ever feeling starved. The check-ins and accountability were game changers for me.",
  },
  {
    initials: "PD",
    name: "Priya D.",
    role: "Thyroid Management",
    text:
      "Friendly, motivating, and incredibly knowledgeable. My TSH stabilised and my sleep and mood transformed completely.",
  },
  {
    initials: "RN",
    name: "Rohan N.",
    role: "Diabetes Reversal Track",
    text:
      "A truly personalised consultation. My HbA1c dropped from 8.2 to 6.1 with steady, sustainable habit work — no medication increase.",
  },
  {
    initials: "MS",
    name: "Meera S.",
    role: "Emotional Eating",
    text:
      "I finally understood why I was eating, not just what. The mindset coaching alongside the plan made all the difference.",
  },
  {
    initials: "AT",
    name: "Aditya T.",
    role: "Lifestyle Transformation",
    text:
      "Professional, warm and science-led. My energy, sleep and confidence have completely shifted — and the changes have stuck.",
  },
  {
    initials: "KJ",
    name: "Kavya J.",
    role: "Post-Pregnancy Recovery",
    text:
      "Gentle, realistic, and effective. I rebuilt strength and lost 9 kg post-delivery without compromising my milk supply.",
  },
  {
    initials: "NP",
    name: "Niharika P.",
    role: "Stress Eating Support",
    text:
      "The long-term habit building is what sets this apart. I feel calmer around food than I have in a decade.",
  },
  {
    initials: "HG",
    name: "Harsh G.",
    role: "Corporate Professional",
    text:
      "Travel-heavy job, terrible sleep, no time. The plan still worked. I'm down 11 kg and my labs look better than they did at 25.",
  },
];

export const HABIT_PLAN = {
  title: "Habit Building Plan",
  tagline:
    "For individuals tired of procrastination, inconsistency, and unhealthy routines — and ready to create lasting positive change.",
  items: [
    "Build willpower, discipline and consistency day by day",
    "Design a personalised routine that fits your life",
    "Break procrastination and reclaim your mornings",
    "Anchor healthier eating without dieting or deprivation",
    "Reset sleep, hydration and daily movement rhythms",
    "Learn simple strategies to bounce back on off days",
    "Track progress with weekly check-ins and journaling",
    "Rewire triggers behind emotional and stress eating",
    "Build identity-level habits — not short bursts of motivation",
    "Become the most consistent version of yourself for life",
  ],
  disclaimer:
    "This plan is not designed for weight loss or therapeutic nutrition. It is exclusively for individuals committed to improving their lifestyle, building better habits, and becoming the best version of themselves through consistency and discipline.",
};

export const FAQS = [
  {
    q: "Is the consultation online or in-person?",
    a: "Both. Most clients work with us entirely online via video and WhatsApp. In-person consultations are available in Bangalore by appointment.",
  },
  {
    q: "Do I need bloodwork before starting?",
    a: "For therapeutic diets (PCOS, thyroid, diabetes) recent bloodwork is strongly recommended. For general fat loss we begin with a detailed assessment and request labs if clinically needed.",
  },
  {
    q: "Will I have to give up rice, roti or my cultural foods?",
    a: "No. Our plans are built around Indian eating patterns and your personal preferences. We focus on the right portions, timing and combinations — not deprivation.",
  },
  {
    q: "How quickly will I see results?",
    a: "Most clients notice changes in energy, sleep and digestion within 2–3 weeks. Visible body composition changes typically begin in week 4–6, with the real transformation compounding over 3–6 months.",
  },
  {
    q: "How does progress tracking work?",
    a: "Weekly check-ins via WhatsApp or video, body composition tracking, symptom logs, and data-led plan adjustments. You're never on your own.",
  },
  {
    q: "Is this safe long-term?",
    a: "Yes. Every plan is evidence-led, clinically aligned and built to be sustainable for life — not a 21-day fix.",
  },
];
